class ModalView extends Backbone.View {
    // A modal dialog utility that can be layered.

    get tagName() {
        return 'div';
    };

    get className() {
        return 'overlay';
    };
    get _base_defaults() {
        return {
            buttons: ['Okay'],
            title: null,
            closeOnEsc: true,
            closeOthers: false,
            mask: {
                color: '#ffffff',
                loadSpeed: 1,
                opacity: '1'
            },
            oneInstance: false,
            load: true,
            url_parameters: {}
        };
    };

    initialize (options) {
        this.mask = null;
        this.target = null;
        this.iframe = null;

        this.options = _.extend({}, this._base_defaults, options);
        if (this.options.closeOthers) {
            ModalView.close_all();
        }

        this.id = ModalView.last_id++;

        ModalView.views[this.id] = this;

        let body = $('body');

        this.$el.css({
            opacity: 0,
            background: '#ffffff',
            width: '100%',
            height: '100%',
            overflow: 'auto',
            '-webkit-overflow-scrolling': 'touch',
            '-webkit-transform': 'translateZ(2px)',
            '-moz-transform': 'translateZ(2px)',
            'transform': 'translateZ(2px)',
            display: 'none',
            position: 'fixed',
            top: '0',
            'z-index': 1200
        });

        // insert this new instance after existing dialogs to place above
        let dialogs = $('div.overlay-dialog');
        if (dialogs.length > 0) {
            this.$el.insertAfter($(dialogs[dialogs.length - 1]));
        } else {
            body.append(this.$el);
        }

        $(window).resize(() => this.resize());
        return this;
    };

    show () {
        if (this.mask) {
            this.mask.fadeIn('fast');
        }
        this.$el.show();

        if (this.options.url) {
            this.render_iframe();
        } else if (this.options.target) {
            this.render_target();
        } else {
            throw 'modal error: no url or target specified';
        }

        return this;
    };

    render_target () {
        this.target = this.options.target;
        this.target.css({
            'z-index': 9999 + this.id
        }).appendTo(this.$el).show();
        this.$el.animate({
            opacity: '1'
        }, 200);
        return this.resize();
    };

    make_frame () {
        return $('<iframe marginheight="0" marginwidth="0" frameborder="0" allowTransparency="true" name="modalframe">').css({
            width: "100%",
            height: "auto",
            maxHeight: window.screen && window.screen.height || window.innerHeight || docElement && docElement.clientHeight || docBody.clientHeight || 0,
            border: "none".css
        });
    };

    _query_string () {
        let params = {
            p: JSON.stringify(this.options.url_parameters),
            parent_url: document.location.href,
            parent_id: this.id
        };
        return '?' + $.param(params);
    };

    navigate (url) {
        // new url to be used as the parent_url in case of secure modals using postMessage
        this.options.url = url;

        // don't hide the frame or IE will refuse to measure the content, which
        // causes the modal to never display
        this.$el.fadeOut(200, () => {
            return this.$el.css({
                opacity: 20
            });
        });

        this.iframe.attr('src', url + this._query_string()).load(() => {
            this.$el.fadeIn(200);
        });
    };

    render_iframe () {
        window.tags.page_event(this.options.url, 'open');
        this.$el.css({
            'z-index': 9999 + this.id
        });

        this.iframe = this.make_frame().attr('src', this.options.url + this._query_string());
        this.resize_on_show();
        this.iframe.appendTo(this.$el);
        this.iframe.load(() => {
            var e, win;
            win = this.iframe[0].contentWindow || this.iframe[0].contentDocument.defaultView;
            try {
                return win.parent_id = this.id;
            } catch (error) {
                // expected error for secure modals
            }
        });

        this.options.onLoad = () => {
            if (this.options.onOpen) {
                return this.options.onOpen($(this.iframe.contents()));
            }
        };
        return this;
    };

    resize_on_show () {
        return this.iframe.load(() => {
            if (this.options.onLoad != null) {
                this.options.onLoad(this.iframe);
            }
            let try_resize = () => {
                // the frame may not be loaded yet, so trying to measure content may fail
                var e;
                try {
                    if (this.iframe[0].contentWindow.document.body.offsetWidth === 0) {
                        setTimeout(try_resize, 100);
                    } else {
                        this.resize();
                    }
                } catch (error) {
                    //  might get a permission denied... this is okay for secured iframes, they will use postMessage
                }
            };
            setTimeout(try_resize, 100);
        });
    };

    resize (height, width) {
        if (typeof height !== 'number') {
            height = parseInt(height, 10);
        }
        if (typeof width !== 'number') {
            width = parseInt(width, 10);
        }

        if (this.iframe) {
            if (!height || !width) {
                try {
                    height = $(this.iframe[0].contentWindow.document.body).outerHeight();
                    width = $(this.iframe[0].contentWindow.document.body).offsetWidth();
                } catch (error) {
                    // IE may raise exceptions on trying to access these too early
                }
            }

            this.iframe.css({
                width: '100%',
                height: `${height}50px`
            });

            this.$el.show().animate({
                opacity: 100
            }, 100);
        }
        if (this.options.onShow) {
            this.options.onShow();
        }
    };

    close () {
        if (this.options.onClose) {
            this.options.onClose();
        }
        if (this.mask) {
            this.mask.remove();
        }
        if (this.target) {
            this.target.hide();
        }
        if (this.iframe) {
            this.iframe.remove();
        }
        this.mask = null;
        this.target = null;
        this.iframe = null;
        this.$el.remove();
        ModalView.views[this.id] = void 0;
        $(".modal-hide").removeClass("modal-hide");
    };

    static close_all () {
        for (let view of ModalView.views) {
            if (view && v.close != null) {
                v.close();
            }
        }
    };

    respond (response) {
        window.tags.page_event(this.options.url, response.name);
        this.close();

        let name = response.name;
        let on_option = this.options[`on${name}`];
        if (on_option) {
            on_option(response);
        } else if (this.options.onResponse) {
            this.options.onResponse(response);
        }
    };

    static post (id, response) {
        let view = ModalView.views[id];
        if (view) {
            view.respond(response);
        }
    };

    static get_view (id) {
        return ModalView.views[id];
    };

};
ModalView.last_id = 1;
ModalView.views = {};


class SecureModal extends ModalView {

    initialize () {
        // the url must have appended the parent's url in the hash to make messaging work
        this.options.closeOthers = true;
        super.initialize.apply(this, arguments);
        this.listen();
        return this;
    };

    listen () {
        // setup a callback for the child window to tell us things
        $.receiveMessage(this.on_message);
    };

    on_message (e) {
        let data = $.parseParams(e.data);
        if (!data.action) {
            return;
        }

        if (data.action === 'resize') {
            this.resize(data.height, data.width);
        }

        if (data.action === 'close') {
            window.tags.page_event(this.options.url, 'close');
            this.close();
        }

        if (data.action === 'respond') {
            this.respond(data);
        }

        if (data.action === 'navigate') {
            this.navigate(data.url);
        }

        if (data.action === 'facebook_connect') {
            window.sign_in_view.facebook_connect({
                onConnect: () => {
                    this.close();
                }
            });
        }
        return true;
    };

    resize_on_show (iframe, dialog) {
        // do nothing, the client window must post a message
    };

};


class LoadingModal extends ModalView {

    initialize (options) {
        super.initialize.apply(this, arguments);
        var div;
        // this.options = _.extend({}, this.defaults, options);
        div = $(`
            <div>
                <div class="loader">Loading...</div>
            </div>
        `);
        div.css({
            background: 'white',
            width: '100%',
            height: '100%',
            border: '0',
            overflow: 'hidden'
        });
        div.find('.loader').css({
            padding: '90px 0',
            'font-size': '24px',
            'line-height': '50px',
            'background-position': '90px 92px',
            display: 'block',
            margin: '0',
            position: 'inherit'
        });
        this.options.target = div;
    };

    show (message) {
        this.options.target.find('.loader').html(message);
        return super.show.apply(this, arguments);
    };

};


// Example simple usage:
//
//  delete_modal = new ModalDialog
//    title:      'Delete Group'
//    body:       'Are you sure you wish to delete this group?'
//    buttons:    ['Cancel', 'Delete Group']
//    onResponse: (response) ->
//      if response.index == 1
//        console.log 'delete group'
//  delete_modal.show()
class ModalDialog extends ModalView {

    get url() {
        return urls.get('modal_dialog');
    };

    get defaults() {
        return {
            buttons: ['Cancel', 'Yes'],
            title: null,
            html: false
        };
    };

    initialize (options) {
        this.defaults.url = this.url;
        this.options = _.extend({}, this.defaults, options);
        this.options.url_parameters = this.options.url_parameters || {};
        this.options.url_parameters.dialog = {
            body: this.options.body,
            title: this.options.title,
            buttons: this.options.buttons,
            html: this.options.html
        };
        return super.initialize.apply(this, arguments);
    };

};


class ModalWarning extends ModalDialog {

    get url() {
        return urls.get('modal_warning');
    };

    get defaults() {
        return {
            buttons: ['Okay'],
            title: null
        };
    };

};

class ModalAjaxError extends ModalDialog {
    // Report an ajax error to the user in a modal dialog

    get url() {
        return urls.get('modal_ajax_error');
    };

    get defaults() {
        return {
            buttons: ['Okay']
        };
    };

};


class CaptchaDialog extends ModalView {

    initialize (options) {
        this.options = _.extend({}, this.defaults, options);
        super.initialize.apply(this, arguments);
        if (this.options.challenge.type === 'sms') {
            this.options.url = urls.get('sms_captcha');
        } else if (this.options.challenge.type === 'ad') {
            this.options.url = urls.get('ad_captcha');
        } else {
            this.options.url = urls.get('recaptcha');
        }
        if (this.options.challenge.captcha_event) {
            this.options.url = this.options.url + this.options.challenge.captcha_event + '/';
            if (this.options.challenge.retry) {
                this.options.url = this.options.url + 'retry/';
            }
        }
        this.options.url_parameters = {
            challenge: this.options.challenge
        };
    };

};


class PopupModal extends ModalView {

    get events() {
        return {
            'click .close_window a': 'close_div'
        };
    };

    get defaults() {
        return {
            buttons: ['Cancel', 'Yes'],
            title: null
        };
    };

    initialize (options) {
        this.options = _.extend({}, this.defaults, options);
        super.initialize.apply(this, arguments);
        if (!this.options.body) {
            throw '"body" is required';
        }
        if (!this.options.title) {
            throw '"title" is required';
        }
        if (!this.options.buttons) {
            throw '"buttons" is required';
        }
        let div = $(`
            <div class='popup-modal'>
                <div class="modal-header">
                    <h1></h1>
                </div>
                <div class="modal-body">
                    <div class="wrapper">
                        <p></p>
                    </div>
                </div>
                <div class="modal-footer"></div>
            </div>
        `);
        div.css({
            background: 'white',
            width: this.options.width || '100%',
            height: '100%',
            'min-height': '250px',
            overflow: 'scroll',
            border: '1px solid #ddd',
            position: 'fixed',
        });
        this.options.target = div;
    };

    show () {
        let body = this.options.body;
        let title = this.options.title;
        let buttons = this.options.buttons;
        this.options.target.find('.modal-header h1').html(title);
        this.options.target.find('.modal-body p').html(body);

        let button_markup = '';
        let key = 0;
        for (let button of buttons) {
            if (buttons.length === (1 * key + 1)) {
                button_markup +=`<a class="button-primary" data-name="${button}" data-index="${key}">${button}</a>`;
            } else {
                button_markup +=`<a class="button-primary-inverse" data-name="${button}" data-index="${key}">${button}</a>`;
            }
            ++key;
        }
        this.options.target.find('.modal-footer').html(button_markup);
        super.show();
        this.respond(this.options, buttons);
        return this;
    };

    respond (options) {
        let key = 0;
        for (let button of options.buttons) {
            $(options.target.find('.modal-footer a')[key]).on('click', this.options.onResponse);
            ++key;
        }
    };

    close_div () {
        return this.close();
    };

};


export function modal_ajax_error_handler (xhr, status, errorstr) {
    let body = 'Sorry, an error has occurred';

    try {
        let message = JSON.parse(xhr.responseText).message;
        if (message) {
            body = message;
        }
    } catch (error) {

    }

    new ModalAjaxError({
        title: 'Error',
        body: body,
        url_parameters: {
            response: xhr.responseText,
            status: status,
            error: errorstr
        }
    }).show();
};


window.CaptchaDialog = CaptchaDialog;
window.ModalView = ModalView;
window.SecureModal = SecureModal;
window.ModalDialog = ModalDialog;
window.PopupModal = PopupModal;
window.LoadingModal = LoadingModal;
window.ModalWarning = ModalWarning;
window.ModalAjaxError = ModalAjaxError;


$(document).ready(function() {
    // close the topmost dialog on escape (if the options allow it)
    $(document).bind('keyup', function(e) {
        if (e.keyCode !== 27) {
            return;
        }

        for (let id = ModalView.last_id; id >= 0; --id) {
            let v = ModalView.views[id];
            if (v && (v.close != null)) {
                if (v.options.closeOnEsc) {
                    v.close();
                }
                break;
            }
        }
        this.close();
    });
});



// WEBPACK FOOTER //
// ./assets/es6/mobile/modal/base.es6